<div class="fixed top-0 left-0 right-0 bottom-0 bg-white/60 dark:bg-gray-900/60 backdrop-blur-[2px] z-50">
  <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-sm px-4">
    <div class="relative flex flex-col items-center justify-center gap-4">
      <div class="relative flex items-center justify-center">
        <app-icons svgClass="w-24 lg:w-28 text-gray-600 dark:text-gray-400 animate-spin [animation-duration:2s]" [icon]="icon()"></app-icons>

        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div class="w-20 h-20 lg:w-24 lg:h-24 border-4 border-gray-400/30 dark:border-gray-500/30 rounded-full animate-ping"></div>
        </div>
      </div>

      <p class="text-sm lg:text-lg font-medium text-gray-600 dark:text-gray-400 animate-pulse">
        {{ message() }}...
      </p>

      <ul
        class="w-full overflow-hidden transition-[max-height,opacity] duration-300 ease-out bg-white dark:bg-gray-800 rounded-lg shadow-lg divide-y divide-gray-100 dark:divide-gray-700"
        [style.max-height]="steps().length ? '50vh' : '0px'"
        [style.opacity]="steps().length ? 1 : 0"
        [class.overflow-y-auto]="steps().length"
      >
        @for (step of steps(); track step.key) {
          <li class="flex items-center gap-3 px-4 py-3">
            <span class="flex-shrink-0 flex items-center justify-center w-5 h-5">
              @switch (step.status) {
                @case ('success') {
                  <app-icons svgClass="w-4 text-green-600 dark:text-green-400" icon="check"></app-icons>
                }
                @case ('failed') {
                  <app-icons svgClass="w-4 text-red-500 dark:text-red-400" icon="circle-x"></app-icons>
                }
                @case ('in_progress') {
                  <app-icons svgClass="w-4 text-blue-500 dark:text-blue-400 animate-spin" icon="spinner-third"></app-icons>
                }
                @default {
                  <span class="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600"></span>
                }
              }
            </span>

            <span
              class="text-sm font-medium truncate flex-1"
              [class.text-gray-800]="step.status !== 'pending'"
              [class.dark:text-gray-200]="step.status !== 'pending'"
              [class.text-gray-400]="step.status === 'pending'"
              [class.dark:text-gray-500]="step.status === 'pending'"
            >
              {{ step.label }}
            </span>

            @if (step.duration_ms != null) {
              <span class="flex-shrink-0 text-xs font-mono text-gray-400 dark:text-gray-500">
                {{ formatDuration(step.duration_ms) }}
              </span>
            }
          </li>
        }
      </ul>
    </div>
  </div>
</div>
